import { detect } from 'detect-browser';

export const isSafari = (): boolean => {
  return detect()?.name === 'safari';
};

export default isSafari;
